import React, { useContext, useState, useEffect } from 'react';
import { Typography, Button, Stack } from '@mui/material';
import MainCard from '../berry/ui-component/cards/MainCard.jsx';
import UserContext from '../context/user.jsx';
import CONFIG from '../config.json';
import api_backup from '../api/backup.js';

function trigger_blob_download(blob, filename) {
	const url = URL.createObjectURL(blob);
	const a = document.createElement('a');
	a.href = url;
	a.download = filename;
	a.click();
	URL.revokeObjectURL(url);
}

export default function Backup() {
	const { session } = useContext(UserContext);
	const [list, set_list] = useState(null);
	const [loading, set_loading] = useState(false);
	const [downloading, set_downloading] = useState(null);

	useEffect(() => {
		if (!session) return;
		set_loading(true);
		api_backup
			.list({ session })
			.then(set_list)
			.catch(console.error)
			.finally(() => set_loading(false));
	}, [session]);

	const handle_download_app_zip = (app_uid) => {
		set_downloading(app_uid);
		fetch(`${CONFIG.api}/api/backup/download_app_zip?session=${encodeURIComponent(session)}&app_uid=${encodeURIComponent(app_uid)}`)
			.then((res) => {
				if (!res.ok) return res.json().then((e) => Promise.reject(e));
				return res.blob();
			})
			.then((blob) => trigger_blob_download(blob, `${app_uid}-data.zip`))
			.catch(console.error)
			.finally(() => set_downloading(null));
	};

	return (
		<MainCard title="Backup">
			{loading ? (
				<Typography color="textSecondary">Loading...</Typography>
			) : !list ? (
				<Typography color="textSecondary">No backup list</Typography>
			) : (
				<Stack spacing={2}>
					{list.app_zips?.filter((z) => z.exists).map((z) => (
						<Button
							key={z.app_uid}
							variant="outlined"
							onClick={() => handle_download_app_zip(z.app_uid)}
							disabled={downloading !== null}
						>
							{downloading === z.app_uid ? 'Downloading...' : `Download ${z.app_uid} data.zip`}
						</Button>
					))}
				</Stack>
			)}
		</MainCard>
	);
}
